import { KeyCodes } from '@gower/utils/src/global/KeyEnum';
export function useClearable(state, props) {
    var getValue = state.getValue, setFocus = state.setFocus, emitChange = state.emitChange, isLoading = state.isLoading, isDisabled = state.isDisabled, isReadonly = state.isReadonly;
    var clearable = props.clearable, onClear = props.onClear, clearableOnEscape = props.clearableOnEscape;
    function clear(event) {
        emitChange(null, event);
        setFocus();
        onClear && onClear();
    }
    function onKeyUp(event) {
        if (event.key === KeyCodes.Escape) {
            if (clearable && clearableOnEscape !== false)
                clear(event);
        }
    }
    function show() {
        return Boolean(clearable &&
            getValue() &&
            !isLoading() &&
            !isDisabled() &&
            !isReadonly());
    }
    return {
        show: show(),
        clear: clear,
        onKeyUp: onKeyUp,
    };
}
